// extracted by mini-css-extract-plugin
module.exports = {"column":"column_column__GFuSb"};